var React = require('react');

function LongArrowLeft (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#0db0e7;fill-rule:evenodd;}")),React.createElement("path",{"id":"Combined-Shape","className":"cls-1","d":"M2.45,6,6.67,1.84l-1-1L0,6.5l5.7,5.62,1-1L2.45,7H47.84V6Z","transform":"translate(0 -0.88)","key":1})]);
}

LongArrowLeft.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 47.84 11.25"};

module.exports = LongArrowLeft;

LongArrowLeft.default = LongArrowLeft;
